define(['./Title', './Subtitle', './Heading', 'angularTable'], (title, subtitle, heading) => {
    return angular.module('edge.platform.widgets.titles', ['angular-table'])
        .directive('gwTitle', title)
        .directive('gwSubtitle', subtitle)
        .directive('gwHeading', heading);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/titles/module.js